module.exports = __webpack_public_path__ + "static/media/carleton_university.dbcd13a2.png";